import ModusServiceModel from "../ModusServiceModel";
import CustomerModel from "@/models/crm/CustomerModel";
import LaboratoryModel from "./LaboratoryModel";
import lodash from "lodash"

export default class LaboratoryClientModel extends ModusServiceModel {
  modelName() {
    return "laboratory-clients";
  }
  defaults() {
    return {
      id: null,
      laboratory_id: null,
      laboratory: null,
      customer_id: null,
      customer: null,
      laboratory_account_number: null,
      name: null,
      business: null,
      phone: null,
      email: null,
      contact: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    };
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      customer_id: val => this.nullStringMutator(val),
      laboratory_account_number: val => this.nullStringMutator(val),
      name: val => this.nullStringMutator(val),
      business: val => this.nullStringMutator(val),
      phone: val => this.nullStringMutator(val),
      email: val => this.nullStringMutator(val),
      contact: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    };
  }
  validation() {
    return {};
  }
  getLaboratory() {
    return this.getRelatedModel(LaboratoryModel, "result_event");
  }
  getCustomer() {
    return this.getRelatedModel(CustomerModel, "customer");
  }
  formatName() {
    if (lodash.trim(this.get("name")) !== "") {
      return lodash.trim(this.get("name"));
    }
    
    return lodash.trim(this.get("business"));
  }
}
